import { Components, Theme } from '@mui/material'

const MuiSwitch: Components<Theme>['MuiTooltip'] = {
  styleOverrides: {
    tooltip: ({ theme }) => ({
      backgroundColor: theme.typographyColors.typographyTwo,
      padding: 10,
      borderRadius: 14,
      fontSize: '14px',
      fontWeight: 400,
      lineHeight: '22px',
    }),
    arrow: ({ theme }) => ({
      color: theme.typographyColors.typographyTwo,
    }),
  },
}

export default MuiSwitch
